import React from "react";
import { analytics } from "dc-core";
import AcrobatReaderIcon from "dc-icons/viewer2021/acrobat_reader_appicon_40.svg";
import styles from "./GetAppDialog.css";
import CustomIcon from "dc-preview-utils/src/components/CustomIcon";
import CommonDialog from "dc-preview-utils/src/components/dialog/CommonDialog";
import { dialogApi } from "components/dialogs";
import localizeComponent from "dc-preview-utils/src/Utils/LocalizationUtil";
import loadTranslation from "utils/TranslationUtil";
import { previewEvents } from "publicApis/Events/previewEvents";
import { eventNames } from "publicApis/constants";
import { modernViewerDropinContext } from "constants/enums";

function GetAppDialog(props) {
  const { showGetAppDialog, setShowDialog, title, subHeading, description } = props;

  const GetAppBody = React.useCallback(
    () => (
      <div>
        <div className={styles.getAppContainer}>
          <CustomIcon url={AcrobatReaderIcon} className={styles.acrobatIcon} />
          <span className={styles.getAppSubHeading}> {subHeading} </span>
        </div>
        <span className={styles.getAppDescription}> {description} </span>
      </div>
    ),
    [subHeading, description]
  );

  const hideDialog = React.useCallback(() => {
    setShowDialog(false);
    dialogApi.hide();
  });

  const openInApp = React.useCallback(() => {
    const eventSender = analytics.getEventSender("verb-add-comment");
    eventSender({
      event: {
        workflow: "acrobat",
        subcategory: "verb-add-comment",
        type: "mobile-redirect"
      },
      custom: {
        "adb.event.context.dcweb.clickcontext": "Viewer"
      }
    });

    previewEvents.trigger(eventNames.OPEN_NATIVE_APP, {
      action: "commenting",
      context: modernViewerDropinContext.STICKY_TOOLS,
      campaignID: `${modernViewerDropinContext.STICKY_TOOLS}-verb-comment-stickynote`
    });
    setShowDialog(false);
    dialogApi.hide();
  });

  React.useEffect(() => {
    showGetAppDialog &&
      dialogApi.show(localizeComponent(CommonDialog, loadTranslation), {
        title,
        confirmLabel: props.intl.formatMessage({ id: "get.app.dialog.confirm" }),
        cancelLabel: props.intl.formatMessage({ id: "get.app.dialog.cancel" }),
        Component: GetAppBody,
        onCancel: hideDialog,
        onConfirm: openInApp,
        variant: "confirmation",
        autoFocusButton: ""
      });
  }, [showGetAppDialog, title]);

  return null;
}

export default React.memo(GetAppDialog);
